var map = {
	"./arrow-bottom.svg": 5,
	"./arrow-left.svg": 6,
	"./arrow-right.svg": 7,
	"./arrow.svg": 8,
	"./arrow2-bottom.svg": 9,
	"./close.svg": 10,
	"./exclamation.svg": 11,
	"./eye.svg": 12,
	"./eye11.svg": 13,
	"./facebook.svg": 14,
	"./heart-fill.svg": 1,
	"./heart.svg": 15,
	"./menu.svg": 16,
	"./more.svg": 17,
	"./origin-facebook.svg": 18,
	"./origin-launcher.svg": 19,
	"./origin-twitch.svg": 20,
	"./origin-vod.svg": 21,
	"./origin-youtube.svg": 22,
	"./paging-next.svg": 23,
	"./paging-pre.svg": 24,
	"./play-gradient.svg": 25,
	"./play.svg": 0,
	"./player-mute.svg": 26,
	"./player-pause.svg": 27,
	"./player-play.svg": 28,
	"./player-unmute.svg": 29,
	"./question.svg": 30,
	"./search.svg": 31,
	"./share-facebook.svg": 32,
	"./share-twitter.svg": 33,
	"./share.svg": 34,
	"./triangle.svg": 35,
	"./twitch.svg": 36,
	"./view-heart-fill.svg": 37,
	"./view-heart.svg": 38,
	"./view-share.svg": 39,
	"./view-siren.svg": 40,
	"./youtube.svg": 41,
	"./zone.svg": 2
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4;